export class ContractInfo {
  contract_number: string;
  contract_open_date: Date | string;
  roes___ru: string;
  roes___kz: string;
  contract_phone: string;
  suppl_org_branch_address___ru: string;
  suppl_org_branch_address___kz: string;
  date_contract_pay_day: string;
  date_check: string;
  ingener_calc___ru: string;
  ingener_calc___kz: string;
  saldo: number;
  saldo_peni: number;
  saldo_duty: number;
  assigned_power: number;
  rate_nds: number;
  contract_consumption_category___ru: string;
  contract_consumption_category___kz: string;
  contract_consumption_category_group___ru: string;
  contract_consumption_category_group___kz: string;
  week_ends: number;
  work_hours: number;
  roes: string;
  suppl_org_branch_address: string;
}

export class Period {
  cur_period: string;
  cur_period_104: string;
}
export class PayDetail {
  bill_id: number;
  contract_number___ru: string;
  contract_number___kz: string;
  contractor_name___ru: string;
  contractor_name___kz: string;
  contractor_jur_address___ru: string;
  contractor_jur_address___kz: string;
  sum_pay: number;
  period_name: string;
  contractnumber: string;
  bin: string;
  region_rid: number;
}

export class PayDetailDTO {
  contractRid: number;
  date: string;
}

export class QiwiPay {
  contractId: number;
  invoiceId: number;
  paySum: string;
  BIN: string;
  contractNumber: string;
}

export class KaspiPay {
  contractnumber: string;
  bin: string;
}

export class PayformPay {
  contractId: number;
  invoiceId: number;
  paySum: string;
  commission: number;
}

export class SmartBillingPay {
  account: string;
  bin: string;
  sid: number;
  lang: string;
}

export class QiwiLink {
  billId: number;
  invoiceUid: string;
  payUrl: string;
}

export class KaspiLink {
  billId: number;
  invoiceUid: string;
  payUrl: string;
}

export class QuestionnaireDetails {
  QuestionnaireDetails() {
    this.text = null as any;
    this.checked = null as any;
  }
  var_rid: number;
  question_detail_name___ru: string;
  question_detail_name___kz: string;
  selector_type: number;
  checked: boolean;
  text: string;
}

export class Questionnaire {
  question_rid: number;
  question_name___ru: string;
  question_name___kz: string;
  is_required: boolean;
  rqd: QuestionnaireDetails[];
}

export class Answers {
  var_rid: number;
  checked: boolean;
  text: string;
}

export class SendAnswersDTO {
  bin: string;
  answers: Answers[];
}
